import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from './redux/actions';
import { store } from '../../utils/store';

export function getLabFeatures() {
  const ret = store.getState().labState.features;
  return ret;
}

export function hasFeature(feature) {
  return getLabFeatures()?.find(f => f.name === feature && f.selected) !== undefined;
}


const Lab = props => {
  return (
    <React.Fragment>
      <h3>Experimental features</h3>
      {props.labFeatures?.map(f => (
        <div key={`feature_${f.name}`} className="modals-checkboxes">
          <input
            type="checkbox"
            className="filter-label"
            checked={f.selected}
            onChange={() => props.changeLabOption(f.name)}
          />
          {f.name}
        </div>
      ))}
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    labFeatures: state.labState.features,
  };
};

Lab.propTypes = {
  changeLabOption: PropTypes.func,
  labFeatures: PropTypes.any,
};

const mapDispatchToProps = dispatch => ({
  changeLabOption: feature => dispatch(actions.changeLabOption(feature)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Lab);
